import { useRouter } from 'next/router'
import SvgRight from '#/assets/images/icons/chevron-right.svg'
import AuthLock from '#/components/AuthLock'
import type {
  ItemProps,
  SectionProps,
  SubItemProps
} from '../MLSDetails/types'
import PublicRecordsData from './PublicRecordsData'
import type { PublicRecordsProps } from './types'

export const Section: React.FC<SectionProps> = ({
  Icon,
  children,
  title,
  onClick
}) => (
  <div
    className='relative flex cursor-pointer items-center px-4 py-5'
    onClick={onClick}
  >
    <AuthLock
      className='items-end p-2.5'
      event={`property_records/${title}`}
      onlyIcon
      requireRole='pro'
      transparent
    />
    <div className='flex-1 overflow-hidden'>
      <div className='mb-2 flex items-center align-baseline'>
        {Icon && <Icon className='mr-1.5 h-4 w-4 flex-none text-gray-900' />}
        <span className='ml-1 truncate text-sm font-medium'>{title}</span>
      </div>
      <div className='ml-1 truncate text-xs text-gray-500'>{children}</div>
    </div>
    <SvgRight className='th-lock-element th-lock-element-hide ml-4 h-4 flex-none text-gray-400' />
  </div>
)

// eslint-disable-next-line react/jsx-no-useless-fragment
export const Item: React.FC<ItemProps> = ({ children }) => <>{children}</>

export const SubItem: React.FC<SubItemProps> = ({ title }) => {
  if (!title) return null

  return (
    <>
      <span>{title}</span>
      <span className='last:hidden'>, </span>
    </>
  )
}

const PublicRecords: React.FC<PublicRecordsProps> = ({
  authenticated,
  publicRecord,
  onDetail
}) => {
  const router = useRouter()
  if (!publicRecord) return null

  function onSectionClick(type: string) {
    onDetail('PublicRecords', type)
    setTimeout(() => {
      router.push(`${location.pathname}#${type}`)
    })
  }

  return (
    <div className='w-full divide-y divide-gray-200 bg-white'>
      <h3 className='px-4 pb-1 pt-2 font-medium'>Public Records</h3>
      <PublicRecordsData
        Item={Item}
        Section={Section}
        SubItem={SubItem}
        authenticated={authenticated}
        publicRecord={publicRecord}
        onSectionClick={onSectionClick}
      />
    </div>
  )
}

export default PublicRecords
